import { Link } from "react-router-dom"

export default function ExitLinks({to, title}) {
    return (
        <Link to={to} className="exit-link">
            <p>{title}</p>
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                <path opacity="0.9" d="M5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L5.46967 17.4697ZM6.53033 18.5303L18.5303 6.53033L17.4697 5.46967L5.46967 17.4697L6.53033 18.5303Z" fill="#fff"/>
                <path d="M9 6H18V15" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </Link>
    )
}